import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import './../../styles/admin/pedido_ver.css';
import * as globals from './../../components/GlobalScripts.js';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { Link, useNavigate } from 'react-router-dom';

const containerStyle = { width: '100%', height: '400px' };

const defaultCenter = { lat: -0.180653, lng: -78.467834 };

function safeJsonParse(maybe) {
    try {
        if (!maybe) return null;
        if (typeof maybe === 'string') return JSON.parse(maybe);
        if (typeof maybe === 'object') return maybe;
        return null;
    } catch {
        return null;
    }
}

function pad2(n) {
    const s = String(n ?? '');
    return s.length === 1 ? `0${s}` : s;
}

function splitOrderDate(order_date) {
    const raw = String(order_date || '');
    if (!raw.includes(' ')) return { date: raw || '', time: '' };
    const [d, t] = raw.split(' ');
    const time = (t || '').slice(0, 5);
    return { date: d || '', time: time || '' };
}

function buildOrderDate(date, time) {
    const d = String(date || '').trim();
    const t = String(time || '').trim();
    if (!d) return '';
    if (!t) return `${d} 10:00:00`;
    return `${d} ${t}:00`;
}

function getDishNombre(dish) {
    if (!dish) return '';
    return String(dish.nombre || dish.name || dish.titulo || '').trim();
}

function normalizeOrderFromCache(raw) {
    const obj = safeJsonParse(raw) || raw;
    if (!obj || typeof obj !== 'object') return null;

    if (obj.dish_info && !obj.snapshot) {
        const di = safeJsonParse(obj.dish_info) || obj.dish_info || {};
        const out = {
            ...di,
            id: obj.id ?? di.id,
            status: obj.status ?? di.status,
            keylogin: obj.account_id ?? obj.keylogin ?? di.keylogin,
            order_date: obj.order_date ?? di.order_date,
            type: obj.type ?? di.type,
        };
        return out;
    }

    return obj;
}

function DishCard({ title, dish }) {
    if (!dish) {
        return (
            <div className="platillo-item" style={{ opacity: 0.85 }}>
                <h5><b>{title}</b></h5>
                <p>—</p>
            </div>
        );
    }

    const nombre = getDishNombre(dish) || '—';
    const desc = dish.descripcion || '';
    const alergenos = dish.alergenos || '';
    const m = dish.macros || {};
    const kcal = m.kcal ?? '';
    const p = m.proteinas ?? '';
    const c = m.carbohidratos ?? '';
    const g = m.grasas ?? '';

    return (
        <div className="platillo-item">
            <h5><b>{title}: {nombre}</b></h5>

            {desc ? <p>{desc}</p> : null}

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 8 }}>
                <p><b>Kcal:</b> {kcal !== '' ? kcal : '—'}</p>
                <p><b>Prot:</b> {p !== '' ? `${p}g` : '—'}</p>
                <p><b>Carb:</b> {c !== '' ? `${c}g` : '—'}</p>
                <p><b>Grasas:</b> {g !== '' ? `${g}g` : '—'}</p>
            </div>

            {alergenos ? (
                <p style={{ marginTop: 8 }}>
                    <b>Alérgenos:</b> {alergenos}
                </p>
            ) : null}
        </div>
    );
}

const Admin_pedido_ver = () => {
    const path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();

    const [user, setUser] = useState({});
    const [userDelivery, setUserDelivery] = useState({});
    const [formDataAddress, setFormDataAddress] = useState({});

    const [orderData, setOrderData] = useState({});

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyBYnh7Tl6Z724ZL3Z_VqCgrUVKPSwGE7l4',
    });

    const snapshot = orderData?.snapshot || {};
    const entry = snapshot?.entry || null;
    const main = snapshot?.main || null;
    const snack = snapshot?.snack || null;

    const orderMeta = orderData?.meta || {};
    const fallbackDate = orderMeta?.day_iso || splitOrderDate(orderData?.order_date).date || '';
    const fallbackTime = splitOrderDate(orderData?.order_date).time || orderData?.time || '10:00';

    const [orderDate, setOrderDate] = useState('');
    const [orderTime, setOrderTime] = useState('');

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            const userParsed = safeJsonParse(user_cache);
            if (userParsed) setUser(userParsed);
        }

        const rawOrder = localStorage.getItem('order');
        const rawPlatillo = localStorage.getItem('platillo');

        const normalized = normalizeOrderFromCache(rawOrder ? safeJsonParse(rawOrder) : (rawPlatillo ? safeJsonParse(rawPlatillo) : null));
        if (normalized) {
            setOrderData(normalized);

            const d = normalized?.meta?.day_iso || splitOrderDate(normalized?.order_date).date || normalized?.date || '';
            const t = splitOrderDate(normalized?.order_date).time || normalized?.time || '10:00';

            setOrderDate(d);
            setOrderTime(t);

            if (normalized?.keylogin) get_user_delivery(normalized.keylogin);
        }
    }, []);

    const get_user_delivery = (keylogin) => {
        globals.openViewCharge();
        axios
            .post(`${path_api}/default/get_user_delivery.php`, {
                rute: globals.getRuteBackend(),
                keylogin,
            })
            .then((response) => {
                if (response.data?.mensaje === 'success') {
                    setUserDelivery(response.data.user || {});
                    setFormDataAddress(response.data.user?.address || {});
                } else {
                    globals.createAlert({
                        type: 'error',
                        msg_title: 'Error',
                        msg: response.data?.mensaje || 'No se obtuvo el usuario',
                        effect: 'opacidad 2s, desplazamiento 2s',
                        time_life: 4000,
                    });
                }
            })
            .catch(() => {
                globals.createAlert({
                    type: 'error',
                    msg_title: 'Error',
                    msg: 'Error al cargar el usuario',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            })
            .finally(() => {
                globals.closeViewCharge();
            });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const finalDate = String(orderDate || fallbackDate || '').trim();
        const finalTime = String(orderTime || fallbackTime || '').trim();

        if (!finalDate) {
            globals.createAlert({
                type: 'error',
                msg_title: 'Error',
                msg: 'Falta la fecha del pedido',
                effect: 'opacidad 2s, desplazamiento 2s',
                time_life: 4000,
            });
            return;
        }

        if (!finalTime) {
            globals.createAlert({
                type: 'error',
                msg_title: 'Error',
                msg: 'Selecciona una hora para la orden',
                effect: 'opacidad 2s, desplazamiento 2s',
                time_life: 4000,
            });
            return;
        }

        const payloadOrder = {
            ...orderData,
            date: finalDate,
            time: finalTime,
            order_date: buildOrderDate(finalDate, finalTime),
        };

        globals.openViewCharge();
        axios
            .post(`${path_api}/update-orders/edit_admin.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                order: payloadOrder,
            })
            .then((response) => {
                if (response.data?.mensaje === 'success') {
                    globals.createAlert({
                        type: 'success',
                        msg_title: 'Éxito',
                        msg: 'Orden actualizada.',
                        effect: 'opacidad 2s, desplazamiento 2s',
                        time_life: 4000,
                    });

                    setOrderData(payloadOrder);

                    localStorage.setItem('platillo', JSON.stringify(payloadOrder));

                    const rawOrder = localStorage.getItem('order');
                    if (rawOrder) {
                        const orderWrapper = safeJsonParse(rawOrder) || {};
                        localStorage.setItem(
                            'order',
                            JSON.stringify({
                                ...orderWrapper,
                                id: payloadOrder.id ?? orderWrapper.id,
                                status: payloadOrder.status ?? orderWrapper.status,
                                account_id: payloadOrder.keylogin ?? orderWrapper.account_id,
                                order_date: payloadOrder.order_date ?? orderWrapper.order_date,
                                type: payloadOrder.type ?? orderWrapper.type,
                                dish_info: {
                                    ...(orderWrapper.dish_info || {}),
                                    ...payloadOrder,
                                },
                            })
                        );
                    }
                } else {
                    globals.createAlert({
                        type: 'error',
                        msg_title: 'Error',
                        msg: response.data?.mensaje || 'Error al actualizar',
                        effect: 'opacidad 2s, desplazamiento 2s',
                        time_life: 4000,
                    });
                }
            })
            .catch(() => {
                globals.createAlert({
                    type: 'error',
                    msg_title: 'Error',
                    msg: 'Error al conectar con el servidor',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            })
            .finally(() => {
                globals.closeViewCharge();
            });
    };

    const handleChangeStatus = (e) => {
        const value = e.target.value;
        setOrderData((prev) => ({ ...(prev || {}), status: value }));
    };

    const handleMapClick = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setFormDataAddress((prev) => ({ ...(prev || {}), lat, lng }));
    };

    const handleMarkerDragEnd = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setFormDataAddress((prev) => ({ ...(prev || {}), lat, lng }));
    };

    const displayDate = orderDate || fallbackDate || '—';
    const displayTime = orderTime || fallbackTime || '—';
    const displayType = orderData?.type || orderMeta?.type || '—';

    return (
        <div className="page-pedido-ver container-section small-section flex-column gap-20">
            <form onSubmit={handleSubmit} className="flex-column gap-20">
                <Link to="/admin/pedidos" className="flex-row gap-5">
                    <svg width="20" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                            d="M24.163 41.125L38.7085 55.6658L38.7088 55.6662C39.2779 56.2353 39.7294 56.9109 40.0374 57.6545C40.3454 58.3981 40.5039 59.1951 40.5039 60C40.5039 60.8049 40.3454 61.6018 40.0374 62.3454C39.7294 63.089 39.2779 63.7647 38.7088 64.3338C38.1397 64.9029 37.464 65.3544 36.7204 65.6624C35.9768 65.9704 35.1798 66.1289 34.375 66.1289C33.5701 66.1289 32.7732 65.9704 32.0296 65.6624C31.2859 65.3544 30.6103 64.9029 30.0412 64.3338L5.04386 39.3365C5.04297 39.3356 5.04207 39.3347 5.04118 39.3338M24.163 41.125L36.5875 12.2125C36.878 11.9219 37.1085 11.577 37.2658 11.1974C37.423 10.8178 37.5039 10.4109 37.5039 10C37.5039 9.5891 37.423 9.18222 37.2658 8.8026C37.1085 8.42298 36.878 8.07805 36.5875 7.7875C36.2969 7.49695 35.952 7.26647 35.5724 7.10923C35.1928 6.95198 34.7859 6.87105 34.375 6.87105C33.9641 6.87105 33.5572 6.95198 33.1776 7.10923C32.798 7.26647 32.453 7.49695 32.1625 7.7875L7.1625 32.7875C6.87148 33.0778 6.64059 33.4226 6.48305 33.8023C6.32551 34.1819 6.24441 34.589 6.24441 35C6.24441 35.411 6.32551 35.818 6.48305 36.1977C6.64059 36.5774 6.87148 36.9222 7.1625 37.2125L5.04118 39.3338M24.163 41.125H90.625C92.2494 41.125 93.8074 40.4797 94.956 39.331C96.1047 38.1824 96.75 36.6244 96.75 35C96.75 33.3755 96.1047 31.8176 94.956 30.669C93.8074 29.5203 92.2495 28.875 90.625 28.875H24.163L38.7085 14.3342L38.7088 14.3338C39.2779 13.7647 39.7294 13.089 40.0374 12.3454C40.3454 11.6018 40.5039 10.8049 40.5039 10C40.5039 9.19513 40.3454 8.39815 40.0374 7.65455C39.7294 6.91095 39.2779 6.2353 38.7088 5.66618C38.1397 5.09705 37.464 4.6456 36.7204 4.33759C35.9768 4.02958 35.1799 3.87105 34.375 3.87105C33.5701 3.87105 32.7731 4.02958 32.0296 4.33759C31.286 4.6456 30.6103 5.09705 30.0412 5.66618L5.04386 30.6635L7.16215 32.7871L5.04118 30.6662M24.163 41.125L5.04118 30.6662M5.04118 39.3338C4.47204 38.7654 4.02043 38.0905 3.71213 37.3475C3.40336 36.6034 3.24441 35.8056 3.24441 35C3.24441 34.1943 3.40336 33.3966 3.71213 32.6525C4.02043 31.9095 4.47204 31.2346 5.04118 30.6662M5.04118 39.3338L5.04118 30.6662"
                            fill="var(--color-primary)"
                            stroke="var(--color-primary)"
                            strokeWidth="6"
                        />
                    </svg>
                    <h4 style={{ color: 'var(--color-primary)' }}>Volver</h4>
                </Link>

                <h3>Pedido</h3>

                <div className="platillo-item">
                    <p>
                        Para el día <b>{displayDate}</b> a las <b>{displayTime}</b> — <b>{displayType}</b>
                    </p>

                    <p>
                        Tipo de servicio (actual): <b>{userDelivery?.nivel?.descripcion || '—'}</b>
                    </p>

                    <div className="flex-column gap-5" style={{ marginTop: 10 }}>
                        <h5>Servicio para:</h5>
                        <p>
                            <b>Nombre:</b> {userDelivery?.account?.nombre || '—'} {userDelivery?.account?.apellidos || ''}
                        </p>
                        <p>
                            <b>Teléfono:</b> {userDelivery?.account?.phone || '—'}
                        </p>
                        <p>
                            <b>Email:</b> {userDelivery?.account?.email || '—'}
                        </p>
                    </div>

                    <div className="form-group" style={{ marginTop: 10 }}>
                        <label htmlFor="order_time">Hora</label>
                        <input
                            id="order_time"
                            type="time"
                            className="input-primary"
                            value={orderTime || ''}
                            onChange={(e) => setOrderTime(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="status">Estatus</label>
                        <select
                            id="status"
                            name="status"
                            value={orderData?.status || 'programado'}
                            onChange={handleChangeStatus}
                            className="input-primary"
                            required
                        >
                            <option value="programado">Programado</option>
                            <option value="enviado">Enviado</option>
                            <option value="entregado">Entregado</option>
                            <option value="cancelado">Cancelado</option>
                        </select>
                    </div>
                </div>

                <DishCard title="Entrada" dish={entry} />
                <DishCard title="Plato fuerte" dish={main} />
                <DishCard title="Snack" dish={snack} />

                <div className="user-delivery">
                    {isLoaded && (
                        <div className="map-container">
                            <h5>
                                <b>Dirección:</b>
                            </h5>
                            <p>
                                {formDataAddress?.direccion || ''}{formDataAddress?.direccion ? ',' : ''}{' '}
                                {formDataAddress?.colonia || ''}{formDataAddress?.colonia ? ',' : ''}{' '}
                                {formDataAddress?.ciudad || ''}{formDataAddress?.ciudad ? ',' : ''}{' '}
                                {formDataAddress?.estado || ''}{formDataAddress?.cp ? ',' : ''}{' '}
                                {formDataAddress?.cp || ''}
                            </p>

                            <GoogleMap
                                mapContainerStyle={containerStyle}
                                center={{
                                    lat: formDataAddress?.lat || defaultCenter.lat,
                                    lng: formDataAddress?.lng || defaultCenter.lng,
                                }}
                                zoom={14}
                                onClick={handleMapClick}
                                options={{
                                    zoomControl: true,
                                    zoomControlOptions: {
                                        position:
                                            window.google && window.google.maps
                                                ? window.google.maps.ControlPosition.RIGHT_CENTER
                                                : undefined,
                                    },
                                }}
                            >
                                {formDataAddress?.lat && formDataAddress?.lng && (
                                    <Marker
                                        position={{ lat: formDataAddress.lat, lng: formDataAddress.lng }}
                                        draggable={true}
                                        onDragEnd={handleMarkerDragEnd}
                                    />
                                )}
                            </GoogleMap>

                            <p>
                                <b>Apartamento:</b> {formDataAddress?.apartamento || '—'}
                            </p>
                            <p>
                                <b>Referencia:</b> {formDataAddress?.referencia || '—'}
                            </p>
                            <p>
                                <b>Comentarios:</b>
                                <br />
                                {formDataAddress?.comentarios || '—'}
                            </p>
                        </div>
                    )}
                </div>

                <div className="buttons-opt">
                    <button className="button-primary" type="submit">
                        Actualizar
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Admin_pedido_ver;
